module.exports = __webpack_public_path__ + "img/noimage.7ac99b26.png";